import type { RouteLocationRaw, RouteRecordRaw } from "vue-router";
import {customAsyncComponent} from "@/functions/customAsyncComponent";
import {LOCALE_CATEGORIES} from "@/assets/locales/categories.ts";

export function getLegalTermsRouteRecord():RouteRecordRaw{
  return {
    name: 'legal',
    path: '/legal-terms',
    component: customAsyncComponent(async () => import('./views/LegalTermsView.vue')),
    meta: {
      noAuth: true,
      localeCategories: [
        LOCALE_CATEGORIES.LEGAL_MENTIONS_GLOBAL,
        //LOCALE_CATEGORIES.MY_ACCOUNT,
        LOCALE_CATEGORIES.ERRORS
      ]
    },
  }
}

export function getLegalTermsRouteLocation():RouteLocationRaw{
  return { name: 'legal'}
}